export default "/images/logo.png?bc03c1b31c17d2091973b45a04b88910";